export default "__VITE_ASSET__CzpKrZgA__"